












































import type { PropType } from "vue"
import type { stadium_base } from "@/@types/stadium/stadium"
import { Vue } from "vue-property-decorator"
import Amap from "@/components/amap.vue"
import AreaPicker from '@/components/areapicker.vue'

export default Vue.extend({
  name: "StadiumBase",
  components: { AreaPicker, Amap },
  props: {
    id      : { type: String, required: true },
    button  : { type: Boolean, default: true },
    editable: { type: Boolean, required: true },
    form    : { type: Object as PropType<stadium_base> },
    show    : { type: Object,
      default() {
        return {
          all          : true,
          name         : true,
          province_id  : true,
          city_id      : true,
          county_id    : true,
          area         : true,
          addr         : true,
          contact      : true,
          sex          : true,
          contact_phone: true,
          phone        : true,
          longitude    : true,
          latitude     : true,
        }
      }
    },
  },
  data() {
    return {
      area: [] as string[],
      city: [] as string[],
      options: [
        // { label: '未知', value: '0' },
        { label: '男', value: '1' },
        { label: '女', value: '2' },
      ],
      rules: {
        name         : { required: true, message: "场馆名称不能为空", trigger: "blur" },
        province_id  : { required: true, message: "场馆地区不能为空", trigger: "blur" },
        addr         : { required: true, message: "详细地址不能为空", trigger: "blur" },
        longitude    : { required: true, message: "经纬度不能为空", trigger: "blur" },
        phone        : { required: true, message: "场馆已经营年限不能为空", trigger: "blur" },
        contact      : { required: true, message: "场馆租赁剩余年限不能为空", trigger: "blur" },
        sex          : { required: true, message: "场馆租赁续签情况不能为空", trigger: "blur" },
        contact_phone: { required: true, message: "场馆总面积不能为空", trigger: "blur" },
      }
    }
  },
  methods: {
    init() {
      this.$nextTick(() => {
        this.area = [String(this.form.province_id.padEnd(6, "0")), String(this.form.city_id.padEnd(6, "0")), String(this.form.county_id)]
      })
    },
    choose_area(value: string[], options: any) {
      this.form.province_id = value[0] as string
      this.form.city_id     = value[1] as string
      this.form.county_id   = value[2] as string
      this.city = []
      for (const option of options) {
        this.city.push(option.label)
      }
    },
    amap_callback(lng: any, lat: any) {
      this.form.longitude = lng
      this.form.latitude  = lat
      /* this.form.setFieldsValue({
        lnglat: `${lng},${lat}`,
      }); */
    },
    submit() {
      const params = this.$deep_copy(this.form)
      params.estimate_id = this.id
      this.$emit("save", params)
    },
    check(): boolean {
      let checked = false
      const form = this.$refs.form as any
      form.validate((valid: boolean, err: any) => {
        checked = valid
      })
      return checked
    },
  }
})
